const FILLER_WORDS = ["um", "uh", "like", "you know", "actually", "basically", "kind of", "sort of", "i mean"];

export function countFillerWords(text) {
  if (!text) return 0;
  const lower = ` ${text.toLowerCase().replace(/[.,!?]/g, "")} `;
  return FILLER_WORDS.reduce((count, w) => count + (lower.split(` ${w} `).length - 1), 0);
}

export function calcWPM(text, durationSeconds) {
  if (!durationSeconds || !text) return 0;
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.round((words / durationSeconds) * 60);
}

export function speakText(text, { onEnd } = {}) {
  if (!window.speechSynthesis) {
    if (onEnd) onEnd();
    return;
  }
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = 1.0;
  utterance.pitch = 1.0;
  if (onEnd) utterance.onend = onEnd;
  window.speechSynthesis.speak(utterance);
}

export function stopSpeaking() {
  if (window.speechSynthesis) window.speechSynthesis.cancel();
}
